import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { GlobalProvider } from './context/GlobalContext';
import { ProtectedRoute } from './components/common/ProtectedRoute';
import { NotFound } from './components/common/NotFound';
import { AppLayout } from './components/layout/AppLayout';
import { Landing } from './pages/Landing/Landing';
import { Overview } from './pages/Overview/Overview';
import { Agents } from './pages/Agents/Agents';
import { Sessions } from './pages/Sessions/Sessions';
import './App.css';

export const API_BASE_URL: string = "https://overwatchai-middleware.onrender.com/api/v1";

function App() {
  return (
    <GlobalProvider>
      <BrowserRouter>
        <div className="app">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
              <Route path="/overview" element={<Overview />} />
              <Route path="/agents" element={<Agents />} />
              <Route path="/sessions" element={<Sessions />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </BrowserRouter>
    </GlobalProvider>
  );
}

export default App;
